import { RevisionData } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { RevisionRequestContent } from './RevisionRequestContent.tsx';

export const getTabContent = (
  activeTab: string,
  {
    appraiserInstructions,
    revisionData,
    previousRevisionsData,
  }: {
    appraiserInstructions: string;
    revisionData?: RevisionData;
    previousRevisionsData?: RevisionData[];
  },
) => {
  if (activeTab === 'appraiser_notes') {
    return (
      <Flex marginTop="1rem" flexDirection="column">
        <Typography variant="body1" color="textSecondary">
          <span
            style={{ display: 'inline' }}
            dangerouslySetInnerHTML={{ __html: appraiserInstructions }}
          />
        </Typography>
      </Flex>
    );
  }
  if (activeTab === 'current_revision' && revisionData) {
    return <RevisionRequestContent revisionData={revisionData} />;
  }
  if (activeTab.startsWith('previous_revision_') && previousRevisionsData) {
    const index = parseInt(activeTab.replace('previous_revision_', ''), 10) - 1;
    const revision = previousRevisionsData[index];
    if (revision) {
      return <RevisionRequestContent revisionData={revision} />;
    }
  }
  return null;
};
